var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-3 col-md-4"},[_c('router-link',{staticClass:"sub-heading d-flex justify-content-center",attrs:{"to":_vm.nextLink}},[_c('div',{staticClass:"singel-product"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.itemImage,"alt":""}})])]),_vm._v(" "),_c('p',{staticClass:"text-center mb-4"},[_vm._v(_vm._s(_vm.item.name))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ffdccb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemCard.vue
// module id = null
// module chunks = 